export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8225.d74a9f77.jpg";